import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
 return twMerge(clsx(inputs));
}

export function extractErrorMessage(data: any, fallback: string = "Ocorreu um erro inesperado."): string {
  if (!data) return fallback;
  if (typeof data === "string") return data;
  if (data instanceof Error) return data.message || fallback;
  
  if (data.error) {
    if (typeof data.error === "string") return data.error;
    if (data.error.json?.message) return String(data.error.json.message);
    if (data.error.message) return String(data.error.message);
    if (typeof data.error.json === "string") return data.error.json;
  }
  if (data.json?.message) return String(data.json.message);
  if (data.message) {
    if (typeof data.message === "string") return data.message;
    if (data.message.json?.message) return String(data.message.json.message);
  }
  if (data.data?.message) return String(data.data.message);
  return fallback;
}

